export const LAUNDRY_ACCESSORIES_DRAWER = 'Laundry Accessories';
export const KITCHEN_FUEL_TYPE = 'Fuel Type';
export const APPLIANCE_TYPE = 'Appliance Type';
export const WASHER = 'Washer';
export const DRYER = 'Dryer';
export const ACCESSORIES = 'Accessories';
export const NONE_VALUE = 'None';
export const LAUNDRY_ADD_TO_CART = 'bundle-mini.bipAddToCart';
export const LAUNDRY_VIEW_BUNDLE = 'bundle-mini.viewBundleClick';